// 根据该模块下的个文件名，来做归类区分：
const zh = {
	group: {
		groupManagement: '网站分组管理',
		omniGroupManagement: '群组管理',
		CREATEGROUP: '创建群组',
		website: '旗下网站',
		store: '旗下门店',
		addWebsite: '添加网站',
		detail: '查看详情',
		noWebsite: '旗下还没网站请前去创建网站',
		noStore: '旗下还没门店请前去创建门店',
		groupName: '群组名称',
		cancel: '取消',
		create: '创建',
		singleAdd: '单个添加',
		batchAdd: '批量添加',
		batchAddTittle: '批量添加网站',
		label: '请按照网站模版文件的格式填写信息并上传',
		download: '下载网站模版',
		add: '添加',
		message: '文件未上传'
	},
	groupDetail: {
		settlementCurrency: '结算币种',
		searchStoreName: '网站',
		omniSearchStoreName: '网站/门店',
		index: '索引',
		storeName: '网站',
		omniStoreName: '门店/网站',
		accId: '网站ID',
		omniAccId: '门店/网站ID',
		storeUrl: '网站URL',
		storeType: '门店类型',
		action: '操作',
		detail: '网站详情',
		modifyGroupName: '修改群组名称',
		groupName: '群组名称',
		comfirm: '确认',
		edit: '编辑',
		copy: '复制',
		message: '群组名称修改成功！'
	},
	webManagement: {
		noWebsite: '您尚未添加网站',
		addWebsite: '添加网站',
		pleaseSubmitName: '请先提交实名认证',
		needSubmitName: '您需要先提交实名认证，再添加网站',
		groupNeedKYC: '您需要先提交实名认证，再添加群组',
		submitName: '提交实名材料',
		contact: '联系客服',
		contactToAdd: '联系客服添加网站',
		noSuportAddBySelf: '目前我们暂不支持自主添加网站，请联系客服，客服会引导你进行审核资料的提交。给您带来的不便，非常抱歉。',
		visible: '显示中网站',
		hidden: '已隐藏网站',
		storeNameUrl: '网站名称/网站url',
		hideWebsite: '隐藏此网站',
		delete: '删除',
		hideTip: '网站设置隐藏后，将不在此列表内展示，您可以点击“已隐藏网站” 查看。',
		hide: '隐藏',
		cancel: '取消',
		deleteTip: '删除网站',
		sureDelete: '是否确认删除该网站？',
		unHide: '取消隐藏',
		unHideReason: '是否确认取消隐藏',
		hideReason: '隐藏理由',
		success: '操作成功',
		confirm: '确认',
		bindShopify: '物流绑定',
		unBindShopify: '解绑物流',
		unlinkText: '未绑定Shopify。请在Shopify后台安装PingPong Connect App绑定，可自动同步物流信息',
		linkIndependent: '物流绑定',
		unlinkIndependent: '物流解绑',
		domain: '请输入您的域名',
		appToken: '请输入App Token',
		independent: '所属独立站',
		linkStatus: '绑定状态',
		webName: '网站',
		webUrl: '网站链接',
		onlyShopify: '当前仅支持Shopify/Woocommerce/Shoplazza建站平台链接到本系统，其他平台正在开发中。',
		linksuccess: '绑定成功',
		linkedTooltip: '链接到您的 %{website} 账户：%{host}',
		linkedTooltipWithStatus: '物流已绑定。链接到您的 %{website} 账户：%{host}',
		unlinkBodyText:
			'<p>确定要将 <b>%{storeName}</b> 从 %{website} 解绑吗？</p><p>解绑后系统将不能自动上传物流信息，物流信息需手动上传</p>',
		unlinkBodyTextForWebsite:
			'<p>确定要将网站 <b>%{storeName}</b> 从 %{website} 解绑吗？</p><p>解绑后系统将不能自动上传物流信息，物流信息需手动上传</p>',
		linkBodyText:
			'<p>一旦将 <b>%{storeName}</b> 绑定到 %{website}，系统将能自动上传物流信息，您无需手动上传</p>',
		linkBodyTextForWebsite:
			'<p>一旦将网站 <b>%{storeName}</b> 绑定到 %{website}，系统将能自动上传物流信息，您无需手动上传</p>',
		linkSuccessBodyText:
			'<p>网站 <b>%{storeName}</b> 已绑定到 %{website}，系统将能自动上传物流信息，您无需手动上传</p>',
		linkSuccessMessage: '绑定成功',
		unlinkSuccessMessage: '解绑成功',
		accIdLabel: 'Acc ID',
		consumerKeyLabel: 'Consumer Key：',
		consumerSecretLabel: 'Consumer Secret：',
		commentWithResubmit: '%{comment}，%{tip}',
		allWebsiteOption: '全部',
		linkedStatusUnlinked: '未绑定',
		linkedStatusLinked: '已绑定',
		searchResultText: '搜索到 %{total} 个关于关键字“%{keyword}”的结果',
		searchSuggestText: '没有找到你的网站? 去 <b>已隐藏网站</b> 试试吧',
		autoUpload: '物流同步操作指引',
		wooTip: '该网址为WooCommerce默认为您分配的网址，用于网站授权，请正确填写',
		require: '必须',
		applePayDomainVerify: 'Apple Pay 域名验证',
		applePayVerifiedTips: '此网站已验证Apple Pay',
		applePayDomainDesc: '如果您集成的是PingPong收银台模式，或者使用支付链，在使用Apple Pay时可以跳过域名验证步骤。其他集成方式比如使用内嵌收银台，Pay button集成方式需要在支持Apple Pay之前先完成域名验证。',
		applePayStep1Title: '步骤1: 下载认证文件',
		applePayStep1Desc: '下载Apple 提供的域名验证文件，此文件用于证明您拥有该域名的控制权。',
		applePayDownloadVerifyFile: '下载验证文件',
		applePayStep2Title: '步骤2: 上传文件到网站',
		applePayStep2Desc: '将下载的验证文件上传到您网站的指定路径。Apple将通过访问此路径来验证您的域名所有权。请确保展示Apple Pay按钮的网站都上传指定文件。',
		applePayUploadPath: '上传路径：您的域名/.well-known/apple-developer-merchantid-domain-association',
		applePayStep3Title: '步骤3: 验证域名',
		applePayStep3Desc: '添加在步骤2中已完成域名文件上传的域名并进行验证。验证成功后，该域名即可在您的网站或应用中使用Apple Pay。',
		applePayAddDomain: '添加域名',
		applePayVerifiedDomain: '已验证域名',
		applePayDomainVerifySuccess: '域名验证通过',
		applePayDomainVerifyFail: '域名验证失败',
		applePayDomainInvalid: '请输入正确的域名',
		deleteApplePayDomainTip: '此操作将删除已验证域名 %{domain}, 是否继续?',
		deleteApplePayDomainTipTitle: '提示'
	},
	addWebDialog: {
		addWebsite: '添加网站',
		webSiteName: '网站',
		writeSiteName: '请填写网站名称',
		websiteUrl: '网站URL',
		storeLink: '平台店铺链接',
		storeLinkPlaceholder: '在亚马逊，eBay等平台上的店铺链接',
		writeWebsiteUrl: '请填写网站主页域名',
		backHome: '返回首页',
		title: '网站找不到？',
		desc: '如果您的网站找不到，请联系客服',
		contactText: '联系客服：pp@pingpongx.com',
		cancel: '取消',
		add: '添加',
		cancelAdd: '取消添加网站',
		cancelFont: '您当前没有添加过网站，取消添加网站可能影响您的审核进度，是否确认取消？',
		secondCancelFont: '您尚未提交，是否继续编辑？',
		yes: '确认取消',
		no: '我再想想',
		closePage: '关闭页面',
		confirm: '确定'
	},
	addStore: {
		tradeType: '贸易类型',
		tradeTypeOfWebsite: '网站贸易类型',
		submitWebsite: '提交网站审核',
		omniSubmitWebsite: '网站管理',
		report: '审核报告',
		storeName: '店铺名称（仅支持英文输入）',
		group: '所属网站分组',
		omniGroup: '所属群组',
		routeWebsiteGroup: '创建网站分组',
		omniRouteWebsiteGroup: '创建群组',

		knownGroupTip: '了解网站分组',
		omniKnownGroupTip: '了解群组',

		knownGroupTipText: '网站分组可用于对贵司的区域、业务等进行权限隔离、对多网站数据进行合并分析等，若不需要，则将使用默认管理。',
		omniKnownGroupTipText: '群组管理可用于对贵司的区域、业务等进行权限隔离、对多网站/门店数据进行合并分析等，若不需要，则将使用默认管理。',

		applicationForm: '商户申请表',
		applicationFormDesc: '请下载填写申请表并签名后上传。',
		businessType: '业务类型',
		pleaseSelect: '请选择',
		noFlowNoHistort: '无独立站运营经验，但有亚马逊，eBay等平台的运营历史',
		hasFlowOrHasHistory: '申请的网站/App已有交易流水',
		websiteFlow: '网站流水',
		websiteUrl: '网站URL',
		independentWebsite: '所属独立站',
		summaryReport: '近3~6个月的【信用卡交易对账单】（实际发生在网站上的）',
		submitReport: 'PayPal、Stripe、GooglePlay或其他支付服务商的对账单，能提现月交易量、拒付率、退款率等信息。',
		picture: '图片',
		fitFiels: 'EXCEL或PDF文件',
		bankStatement: '近3-6个月电商平台上的交易对账单',
		ifFirstBussiness: '如亚马逊交易对账单',
		websiteUrlProvide: '网站域名注册证明',
		websiteUrlProvideDesc: '请提供网站域名购买记录等信息，需要体现具体的域名、域名购买人、有效期等信息。',
		submitMes: '提交网站信息',
		cancel: '取消',
		getFail: '获取信息失败，请联系管理员',
		pleaseSubmit: '请上传',
		relevantDocs: '相关材料',
		closeField: '相关文件',
		submitSuccess: '提交成功',
		submitFail: '提交失败，请重试',
		checking: '您的网站信息审核中，请耐心等待',
		checkPass: '您的网站信息已审核通过',
		checkFail: '您提交的网站信息因为资料缺失或者信息错误原因，导致审核失败，请重新提交。',
		checkNotFit: '很遗憾，您目前不符合条件。',
		additional: '附加信息',
		pleaseUploadFlow: '请上传流水证明',
		pleaseWriteName: '请填写店铺名称，最大支持240个字符',
		pleaseWriteUrl: '请填写网站URL，最大支持240个字符',
		pleaseWriteLink: '请填写平台店铺链接',
		pleaseWriteLinkRule: '最大支持240个字符',

		_independentWebsite: '请选择',
		pleaseUploadApplication: '请上传商户申请表',
		pleaseSelectType: '请选择网站类型',
		pleaseUploadFlowWeb: '请上传网站流水文件',
		pleaseMoneyReport: '请上传财务报表文件',
		pleaseUploadBild: '请上传银行对账单文件',
		pleaseUploadProvide: '请上传网站域名注册证明',
		searchSuccess: '查询成功',
		addSuccess: '恭喜你，网站添加成功',
		addFailed: '很遗憾，添加失败',
		inLength: '长度在 2 到 100 个字符',
		pleaseSelectGroup: '请选择所属群组',
		warnTip: [
			'请确保贵司满足以下要求：',
			'1）主体要求：大陆/香港/欧洲/美国的公司（非个体 ）；',
			'2) 有跨境电商经验：如独立站经营者，或平台大卖转独立站;',
			'3) 有跨境实践基础：月交易流水需大于等于 10 万美金，包括但不限于大卖、PayPal、其他收单交易; ',
			'4) 拒付可控，CB 小于等于1%;',
			'5）非站群、仿品、不发货等不良业态。'
		],
		transactionHistory: '历史交易证明',
		transactionHistoryTip: '平台的历史交易证明，6-12 个月的【信用卡交易对账单】（实际发生在该平台上的）。如：PayPal 或其他支付服务商的对账单，交易明细等，能体现月交易量、拒付率、欺诈率、退款率等信息。',
		financialDoc: '财务证明（选填）',
		financialDocTip: '公司的财务状况证明。',
		websiteDoc: '网站域名证书',
		websiteDocTip: '需包含以下关键信息：域名全称、域名持有人/注册人信息、域名注册日期、域名到期日期、域名注册商信息。',
		pci: 'PCI资质',
		pciTip: '支付卡行业数据安全标准(Payment Card <br/>Industry Data Security Standard, PCI DSS)<br/>的合规证明文件。',
		dueDiligence: '尽职调查',
		dueDiligenceTip: '平台对于子商户的审核标准/政策，尽职调查流程。',
		prohibitedItems: '货品禁限售清单',
		prohibitedItemsTip: '平台自身的货品禁限售清单。',
		disputeProcedures: '争议调查材料',
		disputeProceduresTip: '平台的争议调查程序或消费者投诉处理机制。',
		riskMonitoring: '风险监控政策',
		riskMonitoringTip: '平台风控机制，包括但不限于: <br/>(1) 书面版本的风险监控政策和程序。<br/>(2) 对平台卖家进行日常监控。<br/>(3) 平台和平台卖家之间的保证金政策。<br/>(4) 平台卖家的奖惩机制(包含清退机制)。<br/>(5) 对可疑交易进行报告。',
		required: '请上传文件'
	},
	webDetail: {
		webMan: '提交网站审核',
		omniWebMan: '网站管理',
		transRecord: '交易记录',
		moneyFlow: '资金流水',
		marginFlow: '保证金流水',
		chargebackRecord: '拒付记录',
		chooseDate: '选择日期',
		date: '时间',
		quicklySelect: '快速选择',
		today: '今天',
		lastWeek: '最近一周',
		lastMonth: '最近一个月',
		lastYear: '最近一年',
		searchWebOrder: '搜索网站订单号',
		transType: '交易类型',
		transState: '交易状态',
		transCurrency: '交易币种',
		searchTransFlow: '搜索交易流水号',
		downloadRecord: 'CSV',
		businessType: '业务类型',
		inOrOut: '收入/支出',
		all: '全部',
		in: '收入',
		out: '支出',
		preAuthorizationConfirmationSuccess: '预授权确认成功',
		preAuthorizationConfirmationFailure: '预授权确认失败',
		refundSuccess: '退款成功',
		refundFailure: '退款失败',
		preAuthorizationSuccess: '预授权成功',
		preAuthorizationFailure: '预授权失败',
		AuthorizationSuccess: '授权成功',
		successPayment: '付款成功',
		failedPayment: '付款失败',
		recordedPayment: '入账成功',
		preAuthorizationCancellationSuccessfully: '预授权取消成功',
		preAuthorizationCancellationFailure: '预授权取消失败',
		processing: '付款中',
		reviewed: '待审核',
		cancelled: '交易撤销',
		currency: '交易币种',
		transactionTime: '交易时间',
		refundTime: '退款时间',

		transactionID: '流水号',
		orderID: '网站订单号',
		omniOrderID: '商户订单号',
		shopifyOrderId: 'Shopify 订单号',

		client: '用户',
		merchantId: '用户id',
		amount: '交易金额',
		status: '交易状态',
		download: '下载',
		moreDetail: '查看更多',
		change: '更换',
		settlementAmount: '提现金额',
		inputTip: '请输入提现金额',
		Minimum: '最低提现金额100元',
		// all: "全部",
		replacement: '更换提现账户',
		application: '申请提现成功～',
		withdrawSuccessful: '提现成功',
		confirmChange: '确认更换',
		depositAmount: '保证金金额',
		checkRemittance: '查看今日打款',
		withdrawal: '提现',
		copy: '复制',
		websiteInforamtion: '网站详情',
		copyed: '已复制到剪贴板',
		copyfailed: '复制失败，请稍后再试',
		settlementNum: '当前可提现金额',
		allFunds: '全部金额',
		paymentToday: '今日尚未打款',
		paymentTip: '今日向您绑定银行账户的预计打款额为',
		withdrawalFee: '提现手续费',
		estimatedTransferredAmount: '预计到账金额',
		confirm: '确认',
		nodata: '暂无数据',
		transactionType: '交易类型',
		threeDS: '3DS验证',
		token: 'Token支付',
		issueCountry: '卡bin国家',
		errorMessage: '失败原因',
		threeDS2: '3DS',
		token2: 'Token',
		paymentBrand: '支付方式',
		createTime: '创建时间',
		fixedFee: '固定手续费',
		attention: '注意！',
		attentionLine1: '实际到账金额可能因中间行及收款银行手续费而和系统预计到账金额产生差异，此部分手续费由中间行及收款银行决定。',
		attentionLine2: '国际汇款时，中间行及收款银行可能会向您收取汇款中转费，以及向收款人收取入账手续费，这些费用将从您的汇款金额中扣除。如您的汇款被收款行退回，以上费用中间行及收款行不做退回。如您对此有异议请咨询中间行、收款银行或收款人。',
		groupName: '群组',
		storeName: '网站',
		storeGroupName: '网站/群组',
		omniStoreGroupName: '门店/网站/群组',
		refundOrderId: '退款流水号',
		storeRefundFlowId: '网站退款流水号',
		platformShareBenefitFee: '分账金额',
		platformShareBenefitCurrency: '分账币种',
		pos: 'POS SN',
		mid: 'MID',
		tid: 'TID',
		rrn: 'RRN',
		tips: '该交易仅支持手动退款，需额外提供以下信息',
		tips2: '仅选项内的银行可支持退款',
		bankName: '银行名称',
		accountName: '银行账户姓名',
		accountNumber: '银行账户号',
		paymentSlip: '付款凭证',
		tradeVoucherId: '交易凭证单号',
		paymentSlipSample: '付款凭证示例',
		downloadPaymentSlip: '下载',
		tradeVoucherIdSample: '交易凭证单号获取方式参见付款凭证示例',
		button: {
			confirm: '确认',
			bind: '绑定',
			unbind: '解绑',
			cancel: '取消',
			continue: '继续'
		}
	},
	withdrawModal: {
		formRules: '金额大于可提现金额，请确认后再次发起.',
		formRules2: '请输入正确的金额(只允许两位小数点）',
		refundRule: '金额大于可退款金额，请确认后再次发起.',
		success: '操作成功',
		failed: '操作失败',
		add: '去添加',
		noWithdrawals: '无法提现',
		noAccount: '您还未添加提现账户 或 已添加的提现账户不支持此币种，请添加后再发起提现'
	},
	tradeDetail: {
		omniStoreRefundFlowId: '商户退款流水号',
		webDetail: '网站详情',
		tadeDetail: '交易明细',
		refund: '退款',
		disbursement: '请款', // 预授权请款
		authVoid: '撤销', // 预授权撤销
		authVoidTip: '你确定要取消这笔金额为 {0} {1} 的交易吗？',
		authCaptureTip: '你确定要请款 {0} {1} 来完成这笔交易吗？',
		transactionStatus: '订单关联记录',
		transactionInformation: '交易信息',
		transactionTime: '交易时间',
		amount: '交易金额',
		paymentDetails: '原始订单信息',
		paymentMethod: '支付方式',
		cardNumber: '支付卡号',
		accountHolder: '持有人姓名',
		cardIssuingCountry: '发卡国家',
		preAuthorizationConfirmation: '预授权确认',
		preAuthorizationCancellation: '预授权取消',
		refundAccount: '退款入账',
		refundAmount: '退款金额',
		refundFee: '返还费用',
		refundMargin: '返回保证金',
		orderAccount: '订单入账',
		totalAmount: '总金额',
		incomingAmount: '入账金额',
		fee: '费用',
		securityDeposit: '保证金',
		// amount: '金额',
		transactionCancelledSuccessfully: '交易取消成功',
		transactionCancellationfailed: '交易取消失败',
		refunding: '退款中',
		riskReview: '待风控审核',
		inTransaction: '交易中',
		totalConfirmation: '预授权确认总金额',
		totalRefundAmount: '退款总金额',
		transactionFee: '交易费用',
		refundFree2nd: '退款费用',
		accountfunds: '余额账户资金变动',
		remainingAmount: '本笔交易剩余可退款金额',
		refundTips1st: '您在此发起的退款，退款记录将无法同步到您的网站,',
		refundTips2nd: '请前往您的网站发起退款。',
		refundTips3nd: '由于本笔资金不支持原路退回，请填写资金退回的银行信息',
		captureTips1st: '您在此发起的请款，请款记录将无法同步到您的网站,',
		captureTips2nd: '请前往您的网站发起请款。',
		accountName: '银行账户名称',
		accountNumber: '银行账户',
		bankCode: '银行代码',
		remainAmount: '本笔交易剩余可确认金额',
		confirmPayment: '交易一旦取消，将无法恢复。',
		cinfirmCancel: '确定取消交易吗？',
		cancelPayment: '取消交易',
		cancelStatus: '取消成功',
		riskOrder: '风险订单后续可能产生拒付，影响您的业务，是否确认该笔订单无风险',
		riskReviews: '交易有风险，等待PingPong审核',
		riskReviewC: '交易有风险，等待卖家审核',
		cancelFont: '是否确认撤销该笔订单，交易一旦撤销，无法恢复',
		risky: '交易存在风险，请您审核',
		riskyTips1: '请在',
		riskyTips2: '前联系持卡人进行确认，过期则交易自动撤销',
		accept: '接受交易',
		cancel: '我再想想',
		cancelDeal: '取消交易',
		riskOrderReject: '风险订单审核拒绝',
		appeal: '放弃申述',
		appealFont: '您确定要放弃申诉吗？放弃后将无法再次提出申诉，请谨慎决定。',
		cancelAppeal: '我再想想',
		chargeBackTip: '拒付状态下无法退款',
		refundOrderId: '退款流水号',
		storeRefundFlowId: '网站退款流水号',
		origintransactionId: '原交易订单号',
		shippingAddress: '收货地址',
		shippingPhone: '收货人电话',
		email: '收货人邮箱',
		issue: '发卡行',
		moreDetail: '查看详情'
	},
	capitalFlow: {
		all: '全部',
		Payment: '付款',
		paymentFee: '付款手续费',
		reserveHolding: '保证金持有',
		refund: '退款',
		refundFee: '退款手续费',
		depositRelease: '保证金退款返还',
		depositExpireRelease: '保证金到期返还',
		chargebackDeduction: '拒付扣款',
		chargebackCancellation: '拒付返还',
		chargebackFee: '拒付手续费',
		chargebackSuppFee: '拒付阶梯手续费',
		withdrawal: '提现',
		withdrawalFee: '提现手续费',
		depositReleaseCancellation: '保证金到期返还撤销',
		flowID: '流水号',
		time: '时间',
		incomingAmount: '收入金额',
		outcomingAmount: '支出金额',
		accountBalance: '账户余额',
		businessType: '业务类型',
		chargebackArbitrationFee: '拒付仲裁费扣款',
		chargebackReturn: '拒付仲裁费返还'
	},
	depositFlow: {
		incomingDeposit: '新增保证金',
		depositReleaseForRefund: '保证金退款返还',
		depositBalance: '保证金到期返还'
	},
	chargeBack: {
		appealDate: '申诉时间',
		chargebackDate: '拒付发生时间',
		chargebackFlowID: '拒付流水号',
		transactionID: '交易流水号',
		appealStatus: '申诉结果',
		search: '搜索',
		cardNumber: '卡号',
		chargebackReason: '拒付原因',
		amount: '交易金额',
		currency: '交易币种',
		transactionTime: '交易时间',
		chargebackAmount: '拒付金额',
		chargebackCurrency: '拒付币种',
		operation: '操作',
		chargebackAppeal: '拒付申诉',
		chargebackCase: '您确定要进行拒付申诉吗？',
		startDate: '开始日期',
		endDate: '结束日期'
	},
	tradeType: {
		debit: '消费',
		refund: '退款',
		auth: '预授权',
		capture: '预授权完成',
		void: '预授权撤销',
		authCapture: '预授权请款',
		approve: '审核通过',
		reject: '审核拒绝',
		processing: '处理中',
		pending: '付款中',
		success: '成功',
		failed: '失败',
		canceled: '取消',
		review: '待审核',
		tradeTime: '交易时间',
		tradeType: '交易类型',
		tradeStatus: '交易状态',
		operator: '操作',
		exportExcel: '导出当前结果',
		tableField: '设置表格显示字段',
		fixedField: '固定字段',
		optionalField: '可选字段',
		saveSeting: '保存设置',
		yes: '是',
		no: '否',
		save: '保存成功',
		savefaile: '保存失败，请稍后再试',
		risky: '交易存在风险，请您审核',
		riskyTips1: '请在',
		riskyTips2: '前联系持卡人进行确认，过期则交易自动撤销',
		accept: '接受交易',
		cancel: '取消交易',
		currentDetails: '当前详情',
		details: '详情',
		tradeNum: '流水号',
		refundNum: '退款流水号',
		riskOrder: '风险订单后续可能产生拒付，影响您的业务，是否确认该笔订单无风险',
		riskReviews: '交易有风险，等待PingPong审核',
		riskReviewC: '交易有风险，等待卖家审核',
		cancelFont: '是否确认撤销该笔订单，交易一旦撤销，无法恢复',
		arn: 'ARN',
		failReason: '失败原因',
		failCode: '错误码'
	},
	tradeChannelRefund: {
		areaCode: '区号',
		areaCodeRequired: '请选择区号',
		accountType: '类型',
		accountName: '银行账户名称',
		accountHolder: '姓名',
		accountNumber: '银行账户',
		email: '邮箱',
		phoneNo: '手机号',
		phoneRequired: '请输入手机号',
		nationalId: '证件号'
	},
	storeOnboarding: {
		title: '店铺状态查询',
		mcc: '商户类别',
		storeStatus: '店铺状态',
		location: '地区',
		submerchantId: '店铺ID',
		submerchantName: '店铺名称',
		storeUrl: '店铺链接',
		businessIdentityNumber: '营业执照号',
		businessAddress: '地址',
		brand: '品牌名称',
		createTime: '创建时间',
		updateTime: '更新时间',
		search: '查询',
		reset: '重置',
		all: '全部',
		close: '禁用',
		open: '正常'
	}
}

export default zh
